import env from './env';
export const ADAPTABLE_VERSION = env.VERSION;
export const ADAPTABLE_PUBLISH_TIMESTAMP = env.PUBLISH_TIMESTAMP;
export const INFINITE_TABLE_LICENSE_KEY = env.INFINITE_TABLE_LICENSE_KEY;
